import adserver, { AxiosError } from 'services/adserver';
import {
  useMutation,
  useQueryClient,
  UseMutationResult,
} from '@tanstack/react-query';
import { monitoringKeys } from './monitoring.keys';
import {
  MonitoringProposalCodes,
  MonitoringUploadResponse,
} from './monitoring.types';

// upload kodów do kampanii
const uploadCampaignCodes = async ({
  campaignId,
  file,
}: {
  campaignId: number;
  file: File;
}): Promise<MonitoringUploadResponse> => {
  const formData = new FormData();
  formData.append('file', file);

  const { data } = await adserver({
    url: `/campaign/${campaignId}/monitoring/uploadCodes`,
    method: 'POST',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
  });

  return data;
};

export const useUploadCampaignCodes = (): UseMutationResult<
  MonitoringUploadResponse,
  AxiosError,
  { campaignId: number; file: File }
> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: uploadCampaignCodes,
    onSuccess: (_data, { campaignId }) =>
      queryClient.invalidateQueries({
        queryKey: monitoringKeys.campaign(campaignId),
      }),
  });
};

const updateProposalCodes = async ({
  proposalId,
  codes,
}: {
  proposalId: number;
  codes: number[];
}): Promise<MonitoringProposalCodes> => {
  const { data } = await adserver({
    url: `/proposal/${proposalId}/monitoring/codes`,
    method: 'PATCH',
    data: { codes },
    headers: {},
  });

  return data;
};

export const useUpdateProposalCodes = (): UseMutationResult<
  MonitoringProposalCodes,
  AxiosError,
  { proposalId: number; codes: number[] }
> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateProposalCodes,
    // Przypisanie zmienia też drzewo available/assigned i overview kampanii,
    // a propozycja nie zna campaignId- unieważniamy całą domenę.
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: monitoringKeys.all }),
  });
};

//DELETE Codes
const deleteMonitoringCodes = async ({
  campaignId,
  codes,
}: {
  campaignId: number;
  codes: number[];
}): Promise<void> => {
  await adserver({
    url: `campaign/${campaignId}/monitoring/codes`,
    method: 'DELETE',
    data: { codes: codes },
    headers: {},
  });
};

export const useDeleteMonitoringCodes = (): UseMutationResult<
  void,
  AxiosError,
  { campaignId: number; codes: number[] }
> => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteMonitoringCodes,
    onSuccess: (_data, { campaignId }) =>
      queryClient.invalidateQueries({
        queryKey: monitoringKeys.campaign(campaignId),
      }),
  });
};
